import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=af12f048&scoped=true"
import script from "./Dot.vue?vue&type=script&lang=ts"
export * from "./Dot.vue?vue&type=script&lang=ts"
import style0 from "./Dot.vue?vue&type=style&index=0&id=af12f048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12f048",
  null
  
)

export default component.exports